export const formatObjectText = (text: string): string => {
    let formatted = text.replace(/\n/g, ' ');
    formatted = formatted.replace(/\s+/g, ' ').trim();
    return formatted;
  };
  
  export const formatText = (text: string): string => {
    let formatted = text.replace(/\n/g, ' ');
    formatted = formatted.replace(/\s+/g, ' ').trim();
    return formatted;
  };
  